import React from 'react';
import type PlanDependenciesReportType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-dependencies-report/index-old.tsx';
import type PlanIncrementType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-increment/index-old.tsx';
import type PlanSummaryType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-summary/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSummaryEmbed = lazyForPaint<typeof PlanSummaryType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-summary-embed-old", jiraSpaEntry: "async-plan-summary-embed-old" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-summary'
			),
		),
	{ ssr: false },
);

export const PlanSummaryEmbedPage = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanSummaryEmbed} pageId="plan-summary-embed-old" shouldShowSpinner />
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanDependenciesReportEmbed = lazyForPaint<typeof PlanDependenciesReportType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-dependencies-report-embed-old", jiraSpaEntry: "async-plan-dependencies-report-embed-old" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-dependencies-report/index-old.tsx'
			),
		),
	{ ssr: false },
);

export const PlanDependenciesReportEmbedPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanDependenciesReportEmbed}
		pageId="plan-dependencies-report-embed-old"
		shouldShowSpinner
	/>
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanIncrementEmbed = lazyForPaint<typeof PlanIncrementType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-increment-embed-old", jiraSpaEntry: "async-plan-increment-embed-old" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-increment/index-old.tsx'
			),
		),
	{ ssr: false },
);

export const PlanIncrementEmbedPage = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanIncrementEmbed} pageId="plan-increment-embed-old" shouldShowSpinner />
);
